import { ExclamationCircleFilled } from "@ant-design/icons"
import {
  Button,
  DatePicker,
  Dropdown,
  Input,
  Menu,
  message,
  Modal,
  Select,
  Space,
  Spin,
  TableColumnType,
} from "antd"
import moment from "moment"
import React, { useEffect, useRef, useState } from "react"
import { Dimen } from "../../models/dimen"
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
  DateTimeFormatSimpleOnlyOne,
  DateTimeFormatSimplePrintCharge,
  DateTimeFormatSimples,
} from "../../models/datetime"
import { EditableColumnType } from "../../compnents/list/EditableList"
import axios from "axios"

type Action = "detail" | "delete" | "filing"

//义诊备案
export const YZBAColumns = (
  startIndex: number,
  onAction: (action: Action, t: any) => void
): TableColumnType<any>[] => {
  
  return [
    {
      title: "序号",
      key: "no",
      align: "center",
      width: "4rem",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      dataIndex: "applicantUserName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "义诊时间",
      dataIndex: "startTime",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return moment(t.startTime).format(DateTimeFormatSimpleOnly) + "~" +
          moment(t.endTime).format(DateTimeFormatSimpleOnly)
      },
    },
    {
      title: "义诊地点",
      dataIndex: "location",
      align: "center",
      width: "12rem",
      ellipsis: true,
    },
    {
      title: "义诊内容",
      dataIndex: "content",
      align: "center",
      width: "16rem",
    },
    {
      title: "审核时间",
      dataIndex: "reviewTime",
      align: "center",
      width: "8rem",
      ellipsis: true,
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus == 5 || t.reviewStatus == 1
                  ? "#FF1B1B"
                  : "#A2A2A2",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      fixed: "right",
      width: "6rem",
      render: function action(_, t) {
        return (
          <Space>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onAction("detail", t)
              }}
            >
              详情
            </Button>
          </Space>
        )
      },
    },
  ]
}

//义诊记录
export const RecordsYZBAColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void
): TableColumnType<any>[] => {
  const columns: TableColumnType<any>[] = [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      dataIndex: "applicantUserName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "义诊时间",
      dataIndex: "startTime",
      align: "center",
      width: "12rem",
      ellipsis: true,
      render: (_, t) => {
        return moment(t.startTime).format(DateTimeFormatSimpleOnly) + "~" +
          moment(t.endTime).format(DateTimeFormatSimpleOnly)
      },
    },
    {
      title: "义诊地点",
      dataIndex: "location",
      align: "center",
      width: "12rem",
      ellipsis: true,
    },
    {
      title: "义诊内容",
      dataIndex: "content",
      align: "center",
      width: "16rem",
    },
    {
      title: "审核时间",
      align: "center",
      width: "9rem",
      ellipsis: true,
      dataIndex: "reviewTime",
      key: "reviewTime",
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      key: "reviewStatusName",
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus === 5 || t.reviewStatus === 1
                  ? "#9A9A9A"
                  : "#FAA440",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "退回原因",
      align: "center",
      dataIndex: "memo",
      key: "memo",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t.memo && (
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                Modal.info({
                  title: "退回原因",
                  content: t.memo,
                  icon: null,
                  okText: "确认",
                  cancelText: "取消",
                  cancelButtonProps: { style: { display: "none" } },
                })
              }}
            >
              查看
            </Button>
          )
        )
      },
    },
    {
      title: "操作",
      width: "8rem",
      align: "center",
      dataIndex: "storehouseTag",
      key: "storehouseTag",
      render: function Element(_, t) {
        return (
          <>
            {t.reviewStatus == 1 && (
              <Button
                type="text"
                size="small"
                style={{ color: "#027AFF", fontSize: "14px" }}
                onClick={() => {
                  onClick("again", t)
                }}
              >
                重新提交
              </Button>
            )}
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                onClick("detail", t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
  return columns
}

//代煎记录
export const DJDPColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void
): TableColumnType<any>[] => {
  const columns: TableColumnType<any>[] = [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      dataIndex: "applicantUserName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "是否委托第三方",
      dataIndex: "isClient",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.isClient == 1 ? "是" : "否"
      },
    },
    {
      title: "委托方机构",
      dataIndex: "clientOrgName",
      align: "center",
      width: "10rem",
      ellipsis: true,
    },
    {
      title: "备案情况",
      dataIndex: "filingStatusName",
      align: "center",
      width: "8rem",
    },
    {
      title: "备案时间",
      dataIndex: "filingTime",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.filingTime
          ? moment(t.filingTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "备案有效期至",
      dataIndex: "filingExpired",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.filingExpired
          ? moment(t.filingExpired).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus == 5 || t.reviewStatus == 1
                  ? "#FF1B1B"
                  : "#A2A2A2",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      fixed: "right",
      width: "10rem",
      render: function action(_, t) {
        return (
          <Space>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onClick("filing", t)
              }}
            >
              再次备案
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onClick("detail", t)
              }}
            >
              详情
            </Button>
          </Space>
        )
      },
    },
  ]
  return columns
}

//代煎记录
export const RecordsDJDPColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void
): TableColumnType<any>[] => {
  const columns: TableColumnType<any>[] = [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      dataIndex: "applicantUserName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "是否委托第三方",
      dataIndex: "isClient",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.isClient == 1 ? "是" : "否"
      },
    },
    {
      title: "委托方机构",
      dataIndex: "clientOrgName",
      align: "center",
      width: "10rem",
      ellipsis: true,
    },
    {
      title: "提交时间",
      dataIndex: "applicantTime",
      align: "center",
      width: "10rem",
      render: (_, t) => {
        return t.applicantTime
          ? moment(t.applicantTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核时间",
      align: "center",
      width: "8rem",
      ellipsis: true,
      dataIndex: "reviewTime",
      key: "reviewTime",
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      key: "reviewStatusName",
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus === 5 || t.reviewStatus === 1
                  ? "#9A9A9A"
                  : "#FAA440",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "退回原因",
      align: "center",
      dataIndex: "memo",
      key: "memo",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t.memo && (
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                Modal.info({
                  title: "退回原因",
                  content: t.memo,
                  icon: null,
                  okText: "确认",
                  cancelText: "取消",
                  cancelButtonProps: { style: { display: "none" } },
                })
              }}
            >
              查看
            </Button>
          )
        )
      },
    },
    {
      title: "操作",
      width: "8rem",
      align: "center",
      dataIndex: "storehouseTag",
      key: "storehouseTag",
      render: function Element(_, t) {
        return (
          <>
            {t.reviewStatus == 1 && (
              <Button
                type="text"
                size="small"
                style={{ color: "#027AFF", fontSize: "14px" }}
                onClick={() => {
                  onClick("again", t)
                }}
              >
                重新提交
              </Button>
            )}
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                onClick("detail", t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
  return columns
}

//贴敷备案
export const ZYTFColumns = (
  startIndex: number,
  onAction: (action: Action, t: any) => void
): TableColumnType<any>[] => {
  
  return [
    {
      title: "序号",
      key: "no",
      align: "center",
      width: "4rem",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      dataIndex: "applicantName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "中医贴敷名称",
      dataIndex: "drugName",
      align: "center",
      width: "12rem",
      ellipsis: true,
    },
    {
      title: "处方用药",
      dataIndex: "prescriptionMedication",
      align: "center",
      ellipsis: true,
    },
    {
      title: "备案情况",
      dataIndex: "filingStatusName",
      align: "center",
      width: "8rem",
    },
    {
      title: "备案时间",
      dataIndex: "filingDate",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.filingDate
          ? moment(t.filingDate).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "备案有效期至",
      dataIndex: "filingValidityDate",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.filingValidityDate
          ? moment(t.filingValidityDate).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus == 5 || t.reviewStatus == 1
                  ? "#FF1B1B"
                  : "#A2A2A2",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      fixed: "right",
      width: "10rem",
      render: function action(_, t) {
        return (
          <Space>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onAction("filing", t)
              }}
            >
              再次备案
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onAction("detail", t)
              }}
            >
              详情
            </Button>
          </Space>
        )
      },
    },
  ]
}

//贴敷记录
export const RecordsColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void
): TableColumnType<any>[] => {
  const columns: TableColumnType<any>[] = [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      align: "center",
      dataIndex: "applicantName",
      width: "6rem",
      ellipsis: true,
      key: "applicantName",
    },
    {
      title: "中医贴敷名称",
      align: "center",
      dataIndex: "drugName",
      width: "12rem",
      ellipsis: true,
      key: "drugName",
    },
    {
      title: "处方用药",
      align: "center",
      dataIndex: "prescriptionMedication",
      width: "10rem",
      ellipsis: true,
      key: "prescriptionMedication",
    },
    {
      title: "提交时间",
      align: "center",
      dataIndex: "createTime",
      key: "createTime",
      width: "8rem",
      ellipsis: true,
      render: (_, t) => {
        return t.createTime
          ? moment(t.createTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核时间",
      align: "center",
      width: "8rem",
      ellipsis: true,
      dataIndex: "reviewTime",
      key: "reviewTime",
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      key: "reviewStatusName",
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus === 5 || t.reviewStatus === 1
                  ? "#9A9A9A"
                  : "#FAA440",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "退回原因",
      align: "center",
      dataIndex: "memo",
      key: "memo",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t.memo && (
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                Modal.info({
                  title: "退回原因",
                  content: t.memo,
                  icon: null,
                  okText: "确认",
                  cancelText: "取消",
                  cancelButtonProps: { style: { display: "none" } },
                })
              }}
            >
              查看
            </Button>
          )
        )
      },
    },
    {
      title: "操作",
      width: "8rem",
      align: "center",
      dataIndex: "storehouseTag",
      key: "storehouseTag",
      render: function Element(_, t) {
        return (
          <>
            {t.reviewStatus == 1 && (
              <Button
                type="text"
                size="small"
                style={{ color: "#027AFF", fontSize: "14px" }}
                onClick={() => {
                  onClick("again", t)
                }}
              >
                重新提交
              </Button>
            )}
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                onClick("detail", t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
  return columns
}

//特色疗法
export const ZYTSLFColumns = (
  startIndex: number,
  onAction: (action: Action, t: any) => void
): TableColumnType<any>[] => {
  // const [a, sets] = useState(false)
  return [
    {
      title: "序号",
      key: "no",
      align: "center",
      width: "4rem",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      dataIndex: "applicantUserName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "项目名称",
      dataIndex: "projectName",
      align: "center",
      width: "12rem",
      ellipsis: true,
    },
    {
      title: "项目类型",
      dataIndex: "projectTypeName",
      align: "center",
      width: "8rem",
    },
    {
      title: "审核时间",
      dataIndex: "reviewTime",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "状态",
      dataIndex: "reviewStatus",
      align: "center",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == "4" || t.reviewStatus == "3"
                  ? "#0CC263"
                  : t.reviewStatus == "5" || t.reviewStatus == "1"
                  ? "#FF1B1B"
                  : "",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      fixed: "right",
      width: "6rem",
      render: function action(_, t) {
        return (
          <Space>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onAction("detail", t)
              }}
            >
              详情
            </Button>
          </Space>
        )
      },
    },
  ]
}

//特色疗法记录
export const RecordsSpecialColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void
): TableColumnType<any>[] => {
  const layout = {
    width: "14px",
    height: "14x",
    marginRight: "4px",
  }
  const columns: TableColumnType<any>[] = [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      align: "center",
      dataIndex: "applicantUserName",
      width: "6rem",
      ellipsis: true,
      key: "applicantUserName",
    },
    {
      title: "项目名称",
      align: "center",
      dataIndex: "projectName",
      width: "12rem",
      ellipsis: true,
      key: "projectName",
    },
    {
      title: "项目类型",
      align: "center",
      dataIndex: "projectTypeName",
      width: "10rem",
      ellipsis: true,
      key: "projectTypeName",
    },
    {
      title: "提交时间",
      align: "center",
      dataIndex: "applicantTime",
      key: "applicantTime",
      width: "8rem",
      ellipsis: true,
      render: (_, t) => {
        return t.applicantTime
          ? moment(t.applicantTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核时间",
      align: "center",
      width: "8rem",
      ellipsis: true,
      dataIndex: "reviewTime",
      key: "reviewTime",
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      key: "reviewStatusName",
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus === 5 || t.reviewStatus === 1
                  ? "#9A9A9A"
                  : "#FAA440",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "退回原因",
      align: "center",
      dataIndex: "memo",
      key: "memo",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t.memo && (
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                Modal.info({
                  title: "退回原因",
                  content: t.memo,
                  icon: null,
                  okText: "确认",
                  cancelText: "取消",
                  cancelButtonProps: { style: { display: "none" } },
                })
              }}
            >
              查看
            </Button>
          )
        )
      },
    },
    {
      title: "操作",
      width: "8rem",
      align: "center",
      dataIndex: "storehouseTag",
      key: "storehouseTag",
      render: function Element(_, t) {
        return (
          <>
            {t.reviewStatus == 1 && (
              <Button
                type="text"
                size="small"
                style={{ color: "#027AFF", fontSize: "14px" }}
                onClick={() => {
                  onClick("again", t)
                }}
              >
                重新提交
              </Button>
            )}
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                onClick("detail", t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
  return columns
}

//传统医学
export const CTYXColumns = (
  startIndex: number,
  onClick: (action: Action, t: any) => void
): TableColumnType<any>[] => {
  // const [a, sets] = useState(false)
  return [
    {
      title: "序号",
      key: "no",
      align: "center",
      width: "4rem",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申报人",
      dataIndex: "applicantName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "申报人证件号码",
      dataIndex: "applicantCardNo",
      align: "center",
      width: "12rem",
      ellipsis: true,
    },
    {
      title: "报考区域",
      dataIndex: "registrationArea",
      align: "center",
      width: "8rem",
    },
    {
      title: "联系方式",
      dataIndex: "contactInformation",
      align: "center",
      width: "8rem",
    },
    {
      title: "备案时间",
      dataIndex: "filingTime",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.filingTime
          ? moment(t.filingTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "有效期至",
      dataIndex: "filingValidityDate",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.filingValidityDate
          ? moment(t.filingValidityDate).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatus",
      align: "center",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == "4" || t.reviewStatus == "3"
                  ? "#0CC263"
                  : t.reviewStatus == "5" || t.reviewStatus == "1"
                  ? "#FF1B1B"
                  : "",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "操作",
      width: "8rem",
      align: "center",
      dataIndex: "storehouseTag",
      key: "storehouseTag",
      render: function Element(_, t) {
        return (
          <>
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                onClick("filing", t)
              }}
            >
              再次备案
            </Button>
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                onClick("detail", t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
}

//传统医学记录
export const RecordsCTYXColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void
): TableColumnType<any>[] => {
  const layout = {
    width: "14px",
    height: "14x",
    marginRight: "4px",
  }
  const columns: TableColumnType<any>[] = [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申报人",
      align: "center",
      dataIndex: "applicantName",
      width: "5rem",
      ellipsis: true,
      key: "applicantName",
    },
    {
      title: "申报人证件号码",
      align: "center",
      dataIndex: "applicantCardNo",
      width: "10rem",
      ellipsis: true,
      key: "applicantCardNo",
    },
    {
      title: "报考区域",
      align: "center",
      dataIndex: "registrationArea",
      width: "6rem",
      ellipsis: true,
      key: "registrationArea",
    },
    {
      title: "联系方式",
      align: "center",
      dataIndex: "contactInformation",
      width: "8rem",
      ellipsis: true,
      key: "contactInformation",
    },
    {
      title: "申请时间",
      align: "center",
      width: "9rem",
      ellipsis: true,
      dataIndex: "applicantTime",
      key: "applicantTime",
      render: (_, t) => {
        return t.applicantTime
          ? moment(t.applicantTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核时间",
      align: "center",
      width: "9rem",
      ellipsis: true,
      dataIndex: "reviewTime",
      key: "reviewTime",
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      key: "reviewStatusName",
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus === 5 || t.reviewStatus === 1
                  ? "#9A9A9A"
                  : "#FAA440",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "退回原因",
      align: "center",
      dataIndex: "memo",
      key: "memo",
      width: "5rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t.memo && (
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                Modal.info({
                  title: "退回原因",
                  content: t.memo,
                  icon: null,
                  okText: "确认",
                  cancelText: "取消",
                  cancelButtonProps: { style: { display: "none" } },
                })
              }}
            >
              查看
            </Button>
          )
        )
      },
    },
    {
      title: "操作",
      width: "8rem",
      align: "center",
      dataIndex: "storehouseTag",
      key: "storehouseTag",
      render: function Element(_, t) {
        return (
          <>
            {t.reviewStatus == 1 && (
              <Button
                type="text"
                size="small"
                style={{ color: "#027AFF", fontSize: "14px" }}
                onClick={() => {
                  onClick("again", t)
                }}
              >
                重新提交
              </Button>
            )}
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                onClick("detail", t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
  return columns
}

//传统医学 学习经历
export const CTYXStudyColumns = (
  AXIOS_IP: string,
  token: string,
  graduationStatus: any[],
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {

  const { Option } = Select

  return [
    {
      title: "操作",
      align: "center",
      width: "64px",
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type="link"
              onClick={() => {
                onclick("add", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type="link"
              onClick={() => {
                onclick("remove", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: "开始日期",
      align: "center",
      width: "8rem",
      ellipsis: true,
      key: "startTime",
      dataIndex: "startTime",
      nextDataIndex: "endTime",
      render: function Element(_, t: any) {
        return (
          <DatePicker
            value={t.startTime}
            onChange={(date: any) => {
              onclick("edit", { ...t, startTime: date })
            }}
            format="YYYY-MM"
            picker="month"
          />
        )
      },
    },
    {
      title: "结束日期",
      dataIndex: "endTime",
      width: "8rem",
      ellipsis: true,
      align: "center",
      nextDataIndex: "school",
      render: function Element(_, t: any) {
        return (
          <DatePicker
            value={t.endTime}
            onChange={(date: any) => {
              onclick("edit", { ...t, endTime: date })
            }}
            format="YYYY-MM"
            picker="month"
          />
        )
      },
    },
    {
      title: "学校",
      dataIndex: "school",
      width: "12rem",
      ellipsis: true,
      editable: true,
      align: "center",
      nextDataIndex: "professional",
      onSave: (prev, next) => {
        onclick("edit", { ...prev, ...next })
      },
    },
    {
      title: "专业",
      dataIndex: "professional",
      width: "10rem",
      ellipsis: true,
      editable: true,
      align: "center",
      nextDataIndex: "graduationStatus",
      onSave: (prev, next) => {
        onclick("edit", { ...prev, ...next })
      },
    },
    {
      title: "毕（结、肄）业",
      dataIndex: "graduationStatus",
      width: "8rem",
      ellipsis: true,
      align: "center",
      onSave: (prev, next) => {
        onclick("edit", { ...prev, ...next })
      },
      render: function Element(_, t: any) {
        return (
          <Select
            value={t.graduationStatus}
            style={{ width: "100%" }}
            onChange={(value) => {
              onclick("edit", { ...t, graduationStatus: value })
            }}
          >
            {graduationStatus?.map((v: any) => {
              return (
                <Option value={v.value} key={v.id}>
                  {v.label}
                </Option>
              )
            })}
          </Select>
        )
      },
    },
  ]
}

//传统医学 工作经历
export const CTYXWorkColumns = (
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {

  return [
    {
      title: "操作",
      align: "center",
      width: "64px",
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type="link"
              onClick={() => {
                onclick("add", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type="link"
              onClick={() => {
                onclick("remove", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '开始日期',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      key:'studyStartDate',
      dataIndex: 'studyStartDate',
      nextDataIndex: 'studyEndDate',
      render: function Element(_, t: any) {
        return (
          <DatePicker
            value={t.studyStartDate}
            onChange={(date: any) => {
              onclick("edit", { ...t, studyStartDate: date })
            }}
            format="YYYY-MM"
            picker="month"
          />
        )
      },
    },
    {
      title: "结束日期",
      dataIndex: "studyEndDate",
      width: "8rem",
      ellipsis: true,
      align: "center",
      nextDataIndex: "unit",
      render: function Element(_, t: any) {
        return (
          <DatePicker
            value={t.studyEndDate}
            onChange={(date: any) => {
              onclick("edit", { ...t, studyEndDate: date })
            }}
            format="YYYY-MM"
            picker="month"
          />
        )
      },
    },
    {
      title: "单位",
      dataIndex: "unit",
      width: "16rem",
      ellipsis: true,
      editable: true,
      align: "center",
      nextDataIndex: 'position',
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
    },
    {
      title: "职位",
      dataIndex: "position",
      width: "8rem",
      ellipsis: true,
      editable: true,
      align: "center",
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
    },
  ]
}

//传统医学 从事专业
export const CTYXEngagedColumns = (
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {

  return [
    {
      title: "操作",
      align: "center",
      width: "64px",
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type="link"
              onClick={() => {
                onclick("add", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type="link"
              onClick={() => {
                onclick("remove", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '开始日期',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      key:'studyStartDate',
      dataIndex: 'studyStartDate',
      nextDataIndex: 'studyEndDate',
      render: function Element(_, t: any) {
        return (
          <DatePicker
            value={t.studyStartDate}
            onChange={(date: any) => {
              onclick("edit", { ...t, studyStartDate: date })
            }}
            format="YYYY-MM"
            picker="month"
          />
        )
      },
    },
    {
      title: "结束日期",
      dataIndex: "studyEndDate",
      width: "8rem",
      ellipsis: true,
      align: "center",
      nextDataIndex: "unit",
      render: function Element(_, t: any) {
        return (
          <DatePicker
            value={t.studyEndDate}
            onChange={(date: any) => {
              onclick("edit", { ...t, studyEndDate: date })
            }}
            format="YYYY-MM"
            picker="month"
          />
        )
      },
    },
    {
      title: "单位",
      dataIndex: "unit",
      width: "14rem",
      ellipsis: true,
      editable: true,
      align: "center",
      nextDataIndex: 'department',
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
    },
    {
      title: "科室",
      dataIndex: "department",
      width: "8rem",
      ellipsis: true,
      editable: true,
      align: "center",
      nextDataIndex: 'position',
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
    },
    {
      title: "职位/职称",
      dataIndex: "position",
      width: "8rem",
      ellipsis: true,
      editable: true,
      align: "center",
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
    },
  ]
}

//体检项目
export const TJXMColumns = (
  startIndex: number,
  onAction: (action: Action, t: any) => void
): TableColumnType<any>[] => {
  return [
    {
      title: "序号",
      key: "no",
      align: "center",
      width: "4rem",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      dataIndex: "applicantName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "项目数量",
      dataIndex: "projectCount",
      align: "center",
      width: "8rem",
    },
    {
      title: "备案时间",
      dataIndex: "reviewTime",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "状态",
      dataIndex: "reviewStatus",
      align: "center",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == "4" || t.reviewStatus == "3"
                  ? "#0CC263"
                  : t.reviewStatus == "5" || t.reviewStatus == "1"
                  ? "#FF1B1B"
                  : "",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      fixed: "right",
      width: "6rem",
      render: function action(_, t) {
        return (
          <Space>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onAction("detail", t)
              }}
            >
              详情
            </Button>
          </Space>
        )
      },
    },
  ]
}

//体检项目记录
export const RecordsTJXMColumns = (
  startIndex: number,
  onAction: (action: Action, t: any) => void
): TableColumnType<any>[] => {
  return [
    {
      title: "序号",
      key: "no",
      align: "center",
      width: "4rem",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      dataIndex: "applicantName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "项目数量",
      dataIndex: "projectCount",
      align: "center",
      width: "8rem",
    },
    {
      title: "提交时间",
      align: "center",
      dataIndex: "applicantTime",
      key: "applicantTime",
      width: "8rem",
      ellipsis: true,
      render: (_, t) => {
        return t.applicantTime
          ? moment(t.applicantTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核时间",
      align: "center",
      width: "8rem",
      ellipsis: true,
      dataIndex: "reviewTime",
      key: "reviewTime",
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      key: "reviewStatusName",
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus === 5 || t.reviewStatus === 1
                  ? "#9A9A9A"
                  : "#FAA440",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "退回原因",
      align: "center",
      dataIndex: "memo",
      key: "memo",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t.memo && (
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                Modal.info({
                  title: "退回原因",
                  content: t.memo,
                  icon: null,
                  okText: "确认",
                  cancelText: "取消",
                  cancelButtonProps: { style: { display: "none" } },
                })
              }}
            >
              查看
            </Button>
          )
        )
      },
    },
    {
      title: "操作",
      width: "8rem",
      align: "center",
      dataIndex: "storehouseTag",
      key: "storehouseTag",
      render: function Element(_, t) {
        return (
          <>
            {t.reviewStatus == 1 && (
              <Button
                type="text"
                size="small"
                style={{ color: "#027AFF", fontSize: "14px" }}
                onClick={() => {
                  onAction("filing", t)
                }}
              >
                重新提交
              </Button>
            )}
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                onAction("detail", t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
}

//外出体检
export const WCTJColumns = (
  startIndex: number,
  onAction: (action: Action, t: any) => void
): TableColumnType<any>[] => {
  return [
    {
      title: "序号",
      key: "no",
      align: "center",
      width: "4rem",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      dataIndex: "applicantName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "外出时间",
      dataIndex: "time",
      align: "center",
      width: "8rem",
      render: (_, t) => {
        return t.startTime
          ? moment(t.startTime).format(DateTimeFormatSimpleOnly) + '~' +
            moment(t.endTime).format(DateTimeFormatSimpleOnly)
          : "-"
      },
    },
    {
      title: "地点",
      dataIndex: "location",
      align: "center",
      width: "10rem",
    },
    {
      title: "备案时间",
      dataIndex: "reviewTime",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimples)
          : "-"
      },
    },
    {
      title: "状态",
      dataIndex: "reviewStatus",
      align: "center",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == "4" || t.reviewStatus == "3"
                  ? "#0CC263"
                  : t.reviewStatus == "5" || t.reviewStatus == "1"
                  ? "#FF1B1B"
                  : "",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      fixed: "right",
      width: "6rem",
      render: function action(_, t) {
        return (
          <Space>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onAction("detail", t)
              }}
            >
              详情
            </Button>
          </Space>
        )
      },
    },
  ]
}

//外出体检记录
export const RecordsWCTJColumns = (
  startIndex: number,
  onAction: (action: Action, t: any) => void
): TableColumnType<any>[] => {
  return [
    {
      title: "序号",
      key: "no",
      align: "center",
      width: "4rem",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      dataIndex: "applicantName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "外出时间",
      dataIndex: "directoryCount",
      align: "center",
      width: "10rem",
      render: (_, t) => {
        return t.startTime
          ? moment(t.startTime).format(DateTimeFormatSimpleOnly) + '~' +
            moment(t.endTime).format(DateTimeFormatSimpleOnly)
          : "-"
      },
    },
    {
      title: "地点",
      dataIndex: "location",
      align: "center",
      width: "10rem",
      ellipsis: true,
    },
    {
      title: "提交时间",
      align: "center",
      dataIndex: "applicantTime",
      key: "applicantTime",
      width: "8rem",
      ellipsis: true,
      render: (_, t) => {
        return t.applicantTime
          ? moment(t.applicantTime).format(DateTimeFormatSimples)
          : "-"
      },
    },
    {
      title: "审核时间",
      align: "center",
      width: "8rem",
      ellipsis: true,
      dataIndex: "reviewTime",
      key: "reviewTime",
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimples)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      key: "reviewStatusName",
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus === 5 || t.reviewStatus === 1
                  ? "#9A9A9A"
                  : "#FAA440",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "退回原因",
      align: "center",
      dataIndex: "memo",
      key: "memo",
      width: "5rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t.memo && (
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                Modal.info({
                  title: "退回原因",
                  content: t.memo,
                  icon: null,
                  okText: "确认",
                  cancelText: "取消",
                  cancelButtonProps: { style: { display: "none" } },
                })
              }}
            >
              查看
            </Button>
          )
        )
      },
    },
    {
      title: "操作",
      width: "8rem",
      align: "center",
      dataIndex: "storehouseTag",
      key: "storehouseTag",
      render: function Element(_, t) {
        return (
          <>
            {t.reviewStatus == 1 && (
              <Button
                type="text"
                size="small"
                style={{ color: "#027AFF", fontSize: "14px" }}
                onClick={() => {
                  onAction("filing", t)
                }}
              >
                重新提交
              </Button>
            )}
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                onAction("detail", t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
}

//抗菌药物
export const KJYWColumns = (
  startIndex: number,
  onAction: (action: Action, t: any) => void
): TableColumnType<any>[] => {
  // const [a, sets] = useState(false)
  return [
    {
      title: "序号",
      key: "no",
      align: "center",
      width: "4rem",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      dataIndex: "applicantUserName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "类型",
      dataIndex: "childFilingTypeName",
      align: "center",
      width: "8rem",
    },
    {
      title: "目录数量",
      dataIndex: "directoryCount",
      align: "center",
      width: "8rem",
    },
    {
      title: "备案情况",
      dataIndex: "filingStatusName",
      align: "center",
      width: "8rem",
    },
    {
      title: "备案时间",
      dataIndex: "filingDate",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.filingDate
          ? moment(t.filingDate).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "备案有效期至",
      dataIndex: "filingValidityDate",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.filingValidityDate
          ? moment(t.filingValidityDate).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatus",
      align: "center",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == "4" || t.reviewStatus == "3"
                  ? "#0CC263"
                  : t.reviewStatus == "5" || t.reviewStatus == "1"
                  ? "#FF1B1B"
                  : "",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      fixed: "right",
      width: "10rem",
      render: function action(_, t) {
        return (
          <Space>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onAction("filing", t)
              }}
            >
              再次备案
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onAction("detail", t)
              }}
            >
              详情
            </Button>
          </Space>
        )
      },
    },
  ]
}

//抗菌药物记录
export const RecordsKJYWColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void
): TableColumnType<any>[] => {
  const columns: TableColumnType<any>[] = [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      align: "center",
      dataIndex: "applicantUserName",
      width: "6rem",
      ellipsis: true,
      key: "applicantUserName",
    },
    {
      title: "类型",
      align: "center",
      dataIndex: "childFilingTypeName",
      width: "10rem",
      ellipsis: true,
      key: "childFilingTypeName",
    },
    {
      title: "目录数量",
      align: "center",
      dataIndex: "directoryCount",
      width: "10rem",
      ellipsis: true,
      key: "directoryCount",
    },
    {
      title: "提交时间",
      align: "center",
      dataIndex: "applicantTime",
      key: "applicantTime",
      width: "8rem",
      ellipsis: true,
      render: (_, t) => {
        return t.applicantTime
          ? moment(t.applicantTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核时间",
      align: "center",
      width: "8rem",
      ellipsis: true,
      dataIndex: "reviewTime",
      key: "reviewTime",
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      key: "reviewStatusName",
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus === 5 || t.reviewStatus === 1
                  ? "#9A9A9A"
                  : "#FAA440",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "退回原因",
      align: "center",
      dataIndex: "memo",
      key: "memo",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t.memo && (
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                Modal.info({
                  title: "退回原因",
                  content: t.memo,
                  icon: null,
                  okText: "确认",
                  cancelText: "取消",
                  cancelButtonProps: { style: { display: "none" } },
                })
              }}
            >
              查看
            </Button>
          )
        )
      },
    },
    {
      title: "操作",
      width: "8rem",
      align: "center",
      dataIndex: "storehouseTag",
      key: "storehouseTag",
      render: function Element(_, t) {
        return (
          <>
            {t.reviewStatus == 1 && (
              <Button
                type="text"
                size="small"
                style={{ color: "#027AFF", fontSize: "14px" }}
                onClick={() => {
                  onClick("again", t)
                }}
              >
                重新提交
              </Button>
            )}
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                onClick("detail", t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
  return columns
}

//抗菌药物 供应目录备案
export const KJYWCatalogColumns = (
  AXIOS_IP: string,
  token: string,
  visible: boolean,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  const [nexIndexCount, setNexIndexCount] = useState<any>()

  const { Option } = Select

  const [categories, setCategories] = useState<any>([]) //类型

  const getData = () => {
    axios({
      url: `${AXIOS_IP}/filingReviewAntibacterial/getAllDrugs`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": token,
      },
      withCredentials: false,
      method: "POST",
    }).then((res) => {
      const data = res.data.data
      setCategories(data)
    })
  }

  useEffect(() => {
    if (visible) {
      getData()
    }
  }, [visible])

  return [
    {
      title: "操作",
      align: "center",
      width: "64px",
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type="link"
              onClick={() => {
                onclick("add", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type="link"
              onClick={() => {
                onclick("remove", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: "分类",
      dataIndex: "parentId",
      align: "center",
      width: "230px",
      ellipsis: true,
      nextDataIndex: nexIndexCount,
      render: function Element(_, t: any) {
        const selectRef = useRef<any>(null)
        return (
          <Select
            ref={selectRef}
            value={t.parentId}
            style={{ width: "100%" }}
            showSearch
            filterOption={(input, option:any) =>
              (option?.children ?? '').toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(value) => {
              onclick("edit", {
                ...t,
                parentId: value,
                drugName: "",
                usagePermission: "",
                usagePermissionName: "",
              })
              selectRef.current?.blur()
            }}
          >
            {categories?.map((v: any) => {
              return (
                <Option
                  key={v.classificationValue}
                  value={v.classificationValue}
                >
                  {v.classificationName}
                </Option>
              )
            })}
          </Select>
        )
      },
    },
    {
      title: "药品通用名",
      dataIndex: "drugName",
      width: "240px",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        const selectRef = useRef<any>(null)
        const [drugNameList, setDrugNameList] = useState<any>([]) //药品类型
        const handleDropdownVisibleChange = (open: any, t: any) => {
          if (open) {
            if (t.parentId) {
              setDrugNameList(
                categories?.filter(
                  (c: any) => c.classificationValue === t.parentId
                )?.[0]?.drugInfoVOList || []
              )
            } else {
              setDrugNameList([])
            }
          } else {
            setDrugNameList([])
          }
        }
        return t.parentId == 28 ? (
          <Input
            value={t.drugName}
            onChange={(e) => {
              onclick("edit", {
                ...t,
                drugName: e.target.value,
                usagePermission: "",
                usagePermissionName: "",
              })
            }}
          />
        ) : (
          <Select
            ref={selectRef}
            value={t.drugName}
            style={{ width: "100%" }}
            showSearch
            filterOption={(input, option:any) =>
              (option?.children ?? '').toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(value) => {
              onclick("edit", { ...t, drugName: value, usagePermission: "", usagePermissionName: '' })
              selectRef.current?.blur()
            }}
            onDropdownVisibleChange={(open) =>
              handleDropdownVisibleChange(open, t)
            }
          >
            {drugNameList?.map((v: any) => {
              return (
                <Option value={v.drugName} key={v.id}>
                  {v.drugName}
                </Option>
              )
            })}
          </Select>
        )
      },
    },
    {
      title: "剂型",
      dataIndex: "dosageForm",
      width: "100px",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        return (
          <Input
            value={t.dosageForm}
            onChange={(e) => {
              onclick("edit", { ...t, dosageForm: e.target.value })
            }}
          />
        )
      },
    },
    {
      title: "规格",
      dataIndex: "specification",
      width: "200px",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        return (
          <Input
            value={t.specification}
            onChange={(e) => {
              onclick("edit", { ...t, specification: e.target.value })
            }}
          />
        )
      },
    },
    {
      title: "使用权限",
      dataIndex: "usagePermissionName",
      width: "140px",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        const [usagePermissionList, setUsagePermissionList] = useState<any>([]) //权限类型
        const handleDropdownVisiblePermissionChange = (open: any, t: any) => {
          if (open) {
            if (t.parentId) {
              const drugs =
                categories?.filter(
                  (c: any) => c.classificationValue === t.parentId
                )?.[0]?.drugInfoVOList || []
              if (drugs.length && t.drugName) {
                setUsagePermissionList(
                  drugs.filter((d: any) => d.drugName === t.drugName)?.[0]
                    ?.scopeOfUseList
                )
              } else {
                setUsagePermissionList([])
              }
            } else {
              setUsagePermissionList([])
            }
          } else {
            setUsagePermissionList([])
          }
        }

        return t.parentId == 28 ? (
          <Select
            value={t.usagePermissionName}
            style={{ width: "100%" }}
            onChange={(value) => {
              const scopeOfUseName =
                value === 1
                  ? "非限制使用"
                  : value === 2
                  ? "限制使用"
                  : value === 3
                  ? "特殊使用"
                  : ""
              onclick("edit", {
                ...t,
                usagePermission: value,
                usagePermissionName: scopeOfUseName,
              })
            }}
          >
            <Option value={1}>非限制使用</Option>
            <Option value={2}>限制使用</Option>
            <Option value={3}>特殊使用</Option>
          </Select>
        ) : (
          <Select
            value={t.usagePermissionName}
            style={{ width: "100%" }}
            onChange={(value) => {
              const fullData = usagePermissionList?.find(
                (c: any) => c.scopeOfUse === value
              )
              onclick("edit", {
                ...t,
                usagePermission: value,
                usagePermissionName: fullData?.scopeOfUseName,
              })
            }}
            onDropdownVisibleChange={(open) =>
              handleDropdownVisiblePermissionChange(open, t)
            }
          >
            {usagePermissionList?.map((v: any) => {
              return (
                <Option value={v.scopeOfUse} key={v.scopeOfUse}>
                  {v.scopeOfUseName}
                </Option>
              )
            })}
          </Select>
        )
      },
    },
    {
      title: "备注",
      dataIndex: "memo",
      width: "200px",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        const [isComposing, setIsComposing] = useState(false)
        return (
          <Input
            value={t.memo}
            onChange={(e) => {
              const value = e.target.value
              onclick("edit", { ...t, memo: value })
            }}
            onBlur={() => {
              if (t.memo?.length > 10) {
                message.warning("备注不能超过10个字")
                onclick("edit", { ...t, memo: t.memo?.slice(0, 10) })
                return
              }
            }}
          />
        )
      },
    },
  ]
}

//抗菌药物 临时目录备案
export const KJYWCatalogTemporaryColumns = (
  AXIOS_IP: string,
  token: string,
  visible: boolean,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {

  const [drugNameList, setDrugNameList] = useState<string[]>([])
  const getData = (drugName = '') => {
    axios({
      url: `${AXIOS_IP}/filingReviewAntibacterial/getDrugsName?drugName=${drugName}`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": token,
      },
      withCredentials: false,
      method: "POST",
    }).then((res) => {
      const data = res.data.data
      setDrugNameList(data || [])
    })
  }

  useEffect(() => {
    if(visible) {
      getData()
    }
  }, [visible])

  return [
    {
      title: "操作",
      align: "center",
      width: "64px",
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type="link"
              onClick={() => {
                onclick("add", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type="link"
              onClick={() => {
                onclick("remove", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: "药品通用名",
      dataIndex: "drugName",
      width: "12rem",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {

        const [isDrugOverlayVisible, setIsDrugOverlayVisible] = useState(false)
        const drugOverlay = (t: any) => {
          return (
            <Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
              {drugNameList?.map((p: any) => (
                <Menu.Item
                  key={p}
                  onClick={() => {
                    getData(p)
                    onclick("edit", { ...t, drugName: p })
                    setIsDrugOverlayVisible(false)
                  }}
                >
                  <Space>
                    <span>{p}</span>
                  </Space>
                </Menu.Item>
              ))}
            </Menu>
          )
        }
        return (
          <Dropdown
            overlay={() => drugOverlay(t)}
            visible={isDrugOverlayVisible}
          >
            <Input
              value={t.drugName}
              onFocus={() => {
                getData(t.drugName)
                setIsDrugOverlayVisible(true)
              }}
              onBlur={() => {
                setTimeout(() => {
                  setIsDrugOverlayVisible(false)
                }, 300)
              }}
              onClick={() => {
                setIsDrugOverlayVisible(true)
              }}
              onChange={(e) => {
                getData(e.target.value)
                onclick("edit", { ...t, drugName: e.target.value })
              }}
            />
          </Dropdown>
        )
      },
    },
    {
      title: "剂型",
      dataIndex: "dosageForm",
      width: "10rem",
      ellipsis: true,
      align: "center",
      nextDataIndex: "specification",
      render: function Element(_, t: any) {
        return (
          <Input
            value={t.dosageForm}
            onChange={(e) => {
              onclick("edit", { ...t, dosageForm: e.target.value })
            }}
          />
        )
      },
    },
    {
      title: "规格",
      dataIndex: "specification",
      width: "10rem",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        return (
          <Input
            value={t.specification}
            onChange={(e) => {
              onclick("edit", { ...t, specification: e.target.value })
            }}
          />
        )
      },
    },
    {
      title: "单位",
      dataIndex: "unit",
      width: "10rem",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        return (
          <Input
            value={t.unit}
            onChange={(e) => {
              onclick("edit", { ...t, unit: e.target.value })
            }}
          />
        )
      },
    },
    {
      title: "数量",
      dataIndex: "count",
      width: "10rem",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        return (
          <Input
            value={t.count}
            onChange={(e) => {
              onclick("edit", { ...t, count: e.target.value })
            }}
          />
        )
      },
    },
    {
      title: "采购次数",
      dataIndex: "procurementCount",
      width: "10rem",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        return (
          <Input
            value={t.procurementCount}
            onChange={(e) => {
              onclick("edit", { ...t, procurementCount: e.target.value })
            }}
          />
        )
      },
    },
  ]
}

//抗菌药物详情 供应
export const KJYWSupplyColumns = (
  startIndex: number
): EditableColumnType<any>[] => {
  return [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "分类",
      dataIndex: "parentName",
      align: "center",
      width: "12rem",
      ellipsis: true,
    },
    {
      title: "品种序号",
      dataIndex: "varietySerialNumber",
      width: "8rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "品规序号",
      dataIndex: "specificationSerialNumber",
      width: "8rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "药品通用名",
      dataIndex: "drugName",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "剂型",
      dataIndex: "dosageForm",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "规格",
      dataIndex: "specification",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "使用权限",
      dataIndex: "usagePermissionName",
      width: "10rem",
      ellipsis: true,
      align: "center",
      render: (_, t) => t?.usagePermissionName || t?.usagePermission,
    },
    {
      title: "备注",
      dataIndex: "memo",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
  ]
}

//抗菌药物详情 临时
export const KJYWTemporaryColumns = (
  startIndex: number
): EditableColumnType<any>[] => {
  return [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "药品通用名",
      dataIndex: "drugName",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "剂型",
      dataIndex: "dosageForm",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "规格",
      dataIndex: "specification",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "单位",
      dataIndex: "unit",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "数量",
      dataIndex: "count",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "采购次数",
      dataIndex: "procurementCount",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
  ]
}

//抗肿瘤
export const KZLYWColumns = (
  startIndex: number,
  onAction: (action: Action, t: any) => void
): TableColumnType<any>[] => {
  // const [a, sets] = useState(false)
  return [
    {
      title: "序号",
      key: "no",
      align: "center",
      width: "4rem",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      dataIndex: "applicantUserName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "目录数量",
      dataIndex: "directoryCount",
      align: "center",
      width: "8rem",
    },
    {
      title: "备案情况",
      dataIndex: "filingStatusName",
      align: "center",
      width: "8rem",
    },
    {
      title: "备案时间",
      dataIndex: "filingDate",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.filingDate
          ? moment(t.filingDate).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "备案有效期至",
      dataIndex: "filingValidityDate",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.filingValidityDate
          ? moment(t.filingValidityDate).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatus",
      align: "center",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == "4" || t.reviewStatus == "3"
                  ? "#0CC263"
                  : t.reviewStatus == "5" || t.reviewStatus == "1"
                  ? "#FF1B1B"
                  : "",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      fixed: "right",
      width: "10rem",
      render: function action(_, t) {
        return (
          <Space>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onAction("filing", t)
              }}
            >
              再次备案
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onAction("detail", t)
              }}
            >
              详情
            </Button>
          </Space>
        )
      },
    },
  ]
}

//抗肿瘤记录
export const RecordsKZLYWColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void
): TableColumnType<any>[] => {
  const columns: TableColumnType<any>[] = [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      align: "center",
      dataIndex: "applicantUserName",
      width: "6rem",
      ellipsis: true,
      key: "applicantUserName",
    },
    {
      title: "目录数量",
      align: "center",
      dataIndex: "directoryCount",
      width: "10rem",
      ellipsis: true,
      key: "directoryCount",
    },
    {
      title: "提交时间",
      align: "center",
      dataIndex: "applicantTime",
      key: "applicantTime",
      width: "8rem",
      ellipsis: true,
      render: (_, t) => {
        return t.applicantTime
          ? moment(t.applicantTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核时间",
      align: "center",
      width: "8rem",
      ellipsis: true,
      dataIndex: "reviewTime",
      key: "reviewTime",
      render: (_, t) => {
        return t.reviewTime
          ? moment(t.reviewTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      key: "reviewStatusName",
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus === 5 || t.reviewStatus === 1
                  ? "#9A9A9A"
                  : "#FAA440",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "退回原因",
      align: "center",
      dataIndex: "memo",
      key: "memo",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t.memo && (
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                Modal.info({
                  title: "退回原因",
                  content: t.memo,
                  icon: null,
                  okText: "确认",
                  cancelText: "取消",
                  cancelButtonProps: { style: { display: "none" } },
                })
              }}
            >
              查看
            </Button>
          )
        )
      },
    },
    {
      title: "操作",
      width: "8rem",
      align: "center",
      dataIndex: "storehouseTag",
      key: "storehouseTag",
      render: function Element(_, t) {
        return (
          <>
            {t.reviewStatus == 1 && (
              <Button
                type="text"
                size="small"
                style={{ color: "#027AFF", fontSize: "14px" }}
                onClick={() => {
                  onClick("again", t)
                }}
              >
                重新提交
              </Button>
            )}
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                onClick("detail", t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
  return columns
}

//抗肿瘤药物
export const KZLYWCatalogColumns = (
  AXIOS_IP: string,
  token: string,
  visible: boolean,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  const [nexIndexCount, setNexIndexCount] = useState<any>()

  const { Option } = Select

  const [categories, setCategories] = useState<any>([]) //类型

  const getData = () => {
    axios({
      url: `${AXIOS_IP}/filingReviewAnticancerDrug/getAllDrugs`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": token,
      },
      withCredentials: false,
      method: "POST",
    }).then((res) => {
      const data = res.data.data
      setCategories(data)
    })
  }

  useEffect(() => {                                                                                                                                                                             
    if (visible) {
      getData()
    }
  }, [visible])

  return [
    {
      title: "操作",
      align: "center",
      width: "64px",
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type="link"
              onClick={() => {
                onclick("add", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type="link"
              onClick={() => {
                onclick("remove", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: "分类",
      dataIndex: "parentValue",
      align: "center",
      width: "230px",
      ellipsis: true,
      nextDataIndex: nexIndexCount,
      render: function Element(_, t: any) {
        const selectRef = useRef<any>(null)
        return (
          <Select
            ref={selectRef}
            value={t.parentValue}
            style={{ width: "100%" }}
            showSearch
            filterOption={(input, option:any) =>
              (option?.children ?? '').toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(value) => {
              onclick("edit", {
                ...t,
                parentValue: value,
                dosageForm: "", 
                dosageFormName: "", 
                specification: "", 
                drugName: "",
                usagePermission: "",
                usagePermissionName: "",
              })
              selectRef.current?.blur()
            }}
          >
            {categories?.map((v: any) => {
              return (
                <Option
                  key={v.classificationValue}
                  value={v.classificationValue}
                >
                  {v.classificationName}
                </Option>
              )
            })}
          </Select>
        )
      },
    },
    {
      title: "药品通用名",
      dataIndex: "drugName",
      width: "240px",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        const selectRef = useRef<any>(null)

        const [drugNameList, setDrugNameList] = useState<any>([]) //药品类型

        const [isOverlayVisible, setIsOverlayVisible] = useState(false)

        const doctorOverlay = (
          <Menu style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {drugNameList?.map((p: any) => (
              <Menu.Item
                key={p.id}
                onClick={() => {
                   onclick("edit", {
                    ...t,
                    drugName: p.drugName,
                    dosageForm: p.dosageForm,
                    dosageFormName: p.dosageFormName,
                    usagePermission: "",
                    usagePermissionName: "",
                  })
                }}
              >
                <Space>
                  <span>{p.drugName}</span>
                </Space>
              </Menu.Item>
            ))}
          </Menu>
        )

        const handleDropdownVisibleChange = (open: any, t: any) => {
          if (open) {
            if (t.parentValue) {
              setDrugNameList(
                categories?.filter(
                  (c: any) => c.classificationValue === t.parentValue
                )?.[0]?.drugInfoVOList || []
              )
            } else {
              setDrugNameList([])
            }
          } else {
            setDrugNameList([])
          }
        }
        return t.parentValue == 5 ? (
          <Dropdown
            overlay={doctorOverlay}
            visible={isOverlayVisible}
          >
            <Input
              value={t.drugName}
              onFocus={() => {
                handleDropdownVisibleChange(true, t)
                setIsOverlayVisible(true)
              }}
              onBlur={() => {
                setTimeout(() => {
                  setIsOverlayVisible(false)
                }, 300)
              }}
              onChange={(e) => {
                handleDropdownVisibleChange(true, t)
                setIsOverlayVisible(true)
                onclick("edit", {
                  ...t,
                  dosageForm: "",
                  dosageFormName: "",
                  drugName: e.target.value,
                  usagePermission: "",
                  usagePermissionName: "",
                })
              }}
            />
          </Dropdown>
        ) : (
          <Select
            ref={selectRef}
            value={t.drugName}
            style={{ width: "100%" }}
            showSearch
            filterOption={(input, option:any) =>
              (option?.children ?? '').toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(value) => {
              const item = drugNameList?.find((d: any) => d.drugName === value)
              onclick("edit", { 
                ...t, 
                dosageForm: item?.dosageForm, 
                dosageFormName: item?.dosageFormName, 
                specification: item?.specification, 
                drugName: value, 
                usagePermission: "", 
                usagePermissionName: '' 
              })
              selectRef.current?.blur()
            }}
            onDropdownVisibleChange={(open) =>
              handleDropdownVisibleChange(open, t)
            }
          >
            {drugNameList?.map((v: any) => {
              return (
                <Option value={v.drugName} key={v.id}>
                  {v.drugName}
                </Option>
              )
            })}
          </Select>
        )
      },
    },
    {
      title: "剂型",
      dataIndex: "dosageFormName",
      width: "100px",
      align: "center",
      render: function Element(_, t: any) {
        return t.parentValue == 5 ? (
          <Input
            value={t.dosageFormName}
            onChange={(e) => {
              onclick("edit", { ...t, dosageForm:e.target.value, dosageFormName: e.target.value })
            }}
          />
        ) : t?.dosageFormName
      },
    },
    {
      title: "规格",
      dataIndex: "specification",
      width: "200px",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        return (
          <Input
            value={t.specification}
            onChange={(e) => {
              onclick("edit", { ...t, specification: e.target.value })
            }}
          />
        )
      },
    },
    {
      title: "使用权限",
      dataIndex: "usagePermissionName",
      width: "140px",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        return (
          <Select
            value={t.usagePermissionName}
            style={{ width: "100%" }}
            onChange={(value) => {
              const scopeOfUseName =
                value === 1
                  ? "非限制使用"
                  : value === 2
                  ? "限制使用"
                  : ""
              onclick("edit", {
                ...t,
                usagePermission: value,
                usagePermissionName: scopeOfUseName,
              })
            }}
          >
            <Option value={1}>非限制使用</Option>
            <Option value={2}>限制使用</Option>
          </Select>
        )
      },
    },
    {
      title: "备注",
      dataIndex: "memo",
      width: "200px",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        return (
          <Input
            value={t.memo}
            onChange={(e) => {
              const value = e.target.value
              onclick("edit", { ...t, memo: value })
            }}
            onBlur={() => {
              if (t.memo?.length > 10) {
                message.warning("备注不能超过10个字")
                onclick("edit", { ...t, memo: t.memo?.slice(0, 10) })
                return
              }
            }}
          />
        )
      },
    },
  ]
}

//抗肿瘤药物详情
export const KZLYWSupplyColumns = (
  startIndex: number
): EditableColumnType<any>[] => {
  return [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "分类",
      dataIndex: "parentName",
      align: "center",
      width: "12rem",
      ellipsis: true,
    },
    {
      title: "品种序号",
      dataIndex: "varietyNo",
      width: "8rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "品规序号",
      dataIndex: "specNo",
      width: "8rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "药品通用名",
      dataIndex: "drugName",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "剂型",
      dataIndex: "dosageFormName",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "规格",
      dataIndex: "specification",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
    {
      title: "使用权限",
      dataIndex: "usagePermissionName",
      width: "10rem",
      ellipsis: true,
      align: "center",
      render: (_, t) => t?.usagePermissionName || t?.usagePermission,
    },
    {
      title: "备注",
      dataIndex: "memo",
      width: "10rem",
      ellipsis: true,
      align: "center",
    },
  ]
}

//三四级手术目录
export const SSJSSColumns = (
  startIndex: number,
  onAction: (action: Action, t: any) => void
): TableColumnType<any>[] => {
  return [
    {
      title: "申请人",
      dataIndex: "applicantUserName",
      align: "center",
      width: "6rem",
      ellipsis: true,
    },
    {
      title: "目录数量",
      dataIndex: "itemCount",
      align: "center",
      width: "8rem",
    },
    {
      title: "报备情况",
      dataIndex: "filingStatusName",
      align: "center",
      width: "8rem",
    },
    {
      title: "报备时间",
      dataIndex: "applicantTime",
      align: "center",
      width: "10rem",
      ellipsis: true,
      render: (_, t) => {
        return t.applicantTime
          ? moment(t.applicantTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      fixed: "right",
      width: "10rem",
      render: function action(_, t) {
        return (
          <Space>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onAction("filing", t)
              }}
            >
              再次报备
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                onAction("detail", t)
              }}
            >
              详情
            </Button>
          </Space>
        )
      },
    },
  ]
}

//三四级手术目录记录
export const RecordsSSJSSColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void
): TableColumnType<any>[] => {
  const columns: TableColumnType<any>[] = [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "申请人",
      align: "center",
      dataIndex: "applicantUserName",
      width: "6rem",
      ellipsis: true,
      key: "applicantUserName",
    },
    {
      title: "目录数量",
      align: "center",
      dataIndex: "itemCount",
      width: "10rem",
      ellipsis: true,
      key: "itemCount",
    },
    {
      title: "提交时间",
      align: "center",
      dataIndex: "applicantTime",
      key: "applicantTime",
      width: "8rem",
      ellipsis: true,
      render: (_, t) => {
        return t.applicantTime
          ? moment(t.applicantTime).format(DateTimeFormatSimplePrintCharge)
          : "-"
      },
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatusName",
      align: "center",
      width: "6rem",
      ellipsis: true,
      key: "reviewStatusName",
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 4 || t.reviewStatus == 3
                  ? "#0CC263"
                  : t.reviewStatus === 5 || t.reviewStatus === 1
                  ? "#9A9A9A"
                  : "#FAA440",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "退回原因",
      align: "center",
      dataIndex: "memo",
      key: "memo",
      width: "6rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t.memo && (
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                Modal.info({
                  title: "退回原因",
                  content: t.memo,
                  icon: null,
                  okText: "确认",
                  cancelText: "取消",
                  cancelButtonProps: { style: { display: "none" } },
                })
              }}
            >
              查看
            </Button>
          )
        )
      },
    },
    {
      title: "操作",
      width: "8rem",
      align: "center",
      dataIndex: "storehouseTag",
      key: "storehouseTag",
      render: function Element(_, t) {
        return (
          <>
          {t.reviewStatus == 1 && (
              <Button
                type="text"
                size="small"
                style={{ color: "#027AFF", fontSize: "14px" }}
                onClick={() => {
                  onClick("again", t)
                }}
              >
                重新提交
              </Button>
            )}
            <Button
              type="text"
              size="small"
              style={{ color: "#027AFF", fontSize: "14px" }}
              onClick={() => {
                onClick("detail", t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
  return columns
}

// 三四级手术目录 报备
export const SSJSSCatalogColumns = (
  AXIOS_IP: string,
  token: string,
  visible: boolean,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  const [nexIndexCount, setNexIndexCount] = useState<any>()

  const { Option } = Select

  const [categories, setCategories] = useState<any>([]) //类型

  const getData = (v?: any) => {
    axios({
      url: `${AXIOS_IP}/surgicalDirectoryInfo/getDirectoryInfoByWord`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": token,
      },
      withCredentials: false,
      method: "POST",
      params: { procedureName: v || "" },
    }).then((res) => {
      const data = res.data.data
      setCategories(data)
    })
  }

  return [
    {
      title: "操作",
      align: "center",
      width: "64px",
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type="link"
              onClick={() => {
                onclick("add", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type="link"
              onClick={() => {
                onclick("remove", t)
              }}
              style={{ fontSize: "24px", padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: "手术操作名称",
      dataIndex: "procedureName",
      width: "240px",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        const [isDrugOverlayVisible, setIsDrugOverlayVisible] = useState(false)

        const drugOverlay = (t: any) => {
          return (
            <Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
              {categories?.map((p: any) => (
                <Menu.Item
                  key={p.id}
                  onClick={() => {
                    onclick("edit", { ...t,  ...p, id: t.id, finallyId: p.id })
                    setIsDrugOverlayVisible(false)
                  }}
                >
                  <Space>
                    <span>{p.procedureName}</span>
                  </Space>
                </Menu.Item>
              ))}
            </Menu>
          )
        }

        return (
          <Dropdown
            overlay={() => drugOverlay(t)}
            visible={isDrugOverlayVisible}
          >
            <Input
              value={t.procedureName}
              onFocus={() => {
                getData(t.procedureName)
                setIsDrugOverlayVisible(true)
              }}
              onBlur={() => {
                setTimeout(() => {
                  setIsDrugOverlayVisible(false)
                }, 300)
              }}
              onClick={() => {
                setIsDrugOverlayVisible(true)
              }}
              onChange={(e) => {
                getData(e.target.value)
                onclick("edit", { ...t, procedureName: e.target.value })
              }}
            />
          </Dropdown>
        )
      },
    },
    {
      title: "编码",
      dataIndex: "primaryCode",
      width: "100px",
      ellipsis: true,
      align: "center",
    },
    {
      title: "类别",
      dataIndex: "procedureCategory",
      width: "200px",
      ellipsis: true,
      align: "center",
    },
    {
      title: "录入权限",
      dataIndex: "entryOption",
      width: "140px",
      ellipsis: true,
      align: "center",
    },
    {
      title: "手术级别",
      dataIndex: "surgeryLevel",
      width: "140px",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        return (
          <Select
            value={t.surgeryLevel}
            style={{ width: "100%" }}
            onChange={(value) => {
              onclick("edit", { ...t, surgeryLevel: value })
            }}
          >
            <Option value="三级手术">三级手术</Option>
            <Option value="四级手术">四级手术</Option>
          </Select>
        )
      }
    },
    {
      title: "备注",
      dataIndex: "conditionDescription",
      width: "200px",
      ellipsis: true,
      align: "center",
      render: function Element(_, t: any) {
        return (
          <Input
            value={t.memo}
            onChange={(e) => {
              const value = e.target.value
              onclick("edit", { ...t, memo: value })
            }}
            onBlur={() => {
              if (t.memo?.length > 10) {
                message.warning("备注不能超过10个字")
                onclick("edit", { ...t, memo: t.memo?.slice(0, 10) })
                return
              }
            }}
          />
        )
      },
    },
  ]
}

//三四级手术目录 详情 
export const SSJSSTemporaryColumns = (
  startIndex: number
): EditableColumnType<any>[] => {
  return [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: "手术操作名称",
      dataIndex: "procedureName",
      ellipsis: true,
      align: "center",
      width: "15rem",
    },
    {
      title: "编码",
      dataIndex: "primaryCode",
      ellipsis: true,
      align: "center",
      width: "5rem",
    },
    {
      title: "类别",
      dataIndex: "procedureCategory",
      ellipsis: true,
      align: "center",
      width: "5rem",
    },
    {
      title: "录入权限",
      dataIndex: "entryOption",
      ellipsis: true,
      align: "center",
      width: "5rem",
    },
    {
      title: "手术级别",
      dataIndex: "surgeryLevel",
      ellipsis: true,
      align: "center",
      width: "5rem",
    },
    {
      title: "备注",
      dataIndex: "memo",
      ellipsis: true,
      align: "center",
      width: "5rem",
    },
  ]
}